// Centralized config. Replace placeholders before going live.
// All contact details + product data + editable copy live here.

export const SITE_CONFIG = {
  brand: "Havo Comfort",
  brandTag: { ru: "Узбекистан", uz: "O'zbekiston" },

  // Contacts
  phoneRaw: "+998507240440",
  phoneDisplay: "+998 50 724 04 40",
  whatsappPhone: "998507240440",
  telegramUsername: "Havo_comfort_uzbekiston",
  instagramUrl: "https://www.instagram.com/havo_comfort/",

  // Editable urgency / delivery / guarantee copy
  deadline: {
    ru: "До конца недели — консультация и подбор модели бесплатно",
    uz: "Hafta oxirigacha model tanlash bo'yicha maslahat bepul",
  },
  delivery: {
    ru: "Доставка по Ташкенту и регионам — уточните у менеджера",
    uz: "Toshkent va hududlarga yetkazib berish — menejerdan aniqlang",
  },
  guarantee: {
    ru: "Гарантия — нужно уточнить у поставщика",
    uz: "Kafolat — yetkazib beruvchidan aniqlashtirish kerak",
  },

  // SEO
  seo: {
    title: {
      ru: "Мобильные охладители воздуха Air Cooler в Ташкенте — от 170$",
      uz: "Toshkentda mobil Air Cooler havo sovutgichlari — 170$ dan",
    },
    description: {
      ru: "Мобильные водяные охладители Air Cooler для дома, магазина, кафе, офиса и склада. Без сложного монтажа. Доставка по Узбекистану.",
      uz: "Uy, do'kon, kafe, ofis va ombor uchun mobil suvli Air Cooler. Murakkab montajsiz. O'zbekiston bo'ylab yetkazib berish.",
    },
  },
};

// Helpers
export const telHref = `tel:${SITE_CONFIG.phoneRaw}`;

export const whatsappLink = (msgRu, msgUz, lang = "ru") => {
  const text = lang === "uz" ? msgUz : msgRu;
  return `https://wa.me/${SITE_CONFIG.whatsappPhone}?text=${encodeURIComponent(text)}`;
};

export const telegramLink = `https://t.me/${SITE_CONFIG.telegramUsername}`;

// Models
export const MODELS = [
  {
    id: "Z-1050",
    price: 170,
    sizeHint: { ru: "20–50 м³ · уточняется", uz: "20–50 m³ · aniqlashtiriladi" },
    desc: {
      ru: "Компактная модель для небольших помещений. Подойдёт для комнаты, квартиры, небольшого офиса или торговой точки.",
      uz: "Kichik joylar uchun ixcham model. Xona, kvartira, kichik ofis yoki savdo nuqtasi uchun mos.",
    },
    image: "/images/aircooler/2.png",
    tier: "compact",
  },
  {
    id: "Z-1250",
    price: 250,
    sizeHint: { ru: "50–80 м³ · уточняется", uz: "50–80 m³ · aniqlashtiriladi" },
    desc: {
      ru: "Универсальная модель для дома, офиса или среднего магазина.",
      uz: "Uy, ofis yoki o'rtacha do'kon uchun universal model.",
    },
    image: "/images/aircooler/3.png",
    tier: "balanced",
  },
  {
    id: "Z-1380",
    price: 350,
    sizeHint: { ru: "70–100 м³ · уточняется", uz: "70–100 m³ · aniqlashtiriladi" },
    desc: {
      ru: "Модель для более просторных помещений: кафе, офис, магазин.",
      uz: "Kengroq joylar uchun model: kafe, ofis, do'kon.",
    },
    image: "/images/aircooler/4.png",
    tier: "popular",
  },
  {
    id: "Z-1530",
    price: 390,
    sizeHint: { ru: "100–200 м³ · уточняется", uz: "100–200 m³ · aniqlashtiriladi" },
    desc: {
      ru: "Мощная модель для кафе, больших торговых зон и производственных помещений.",
      uz: "Kafe, katta savdo hududlari va ishlab chiqarish joylari uchun kuchli model.",
    },
    image: "/images/aircooler/5.png",
    tier: "power",
  },
  {
    id: "Z-900",
    price: 499,
    sizeHint: { ru: "200–600 м³ · уточняется", uz: "200–600 m³ · aniqlashtiriladi" },
    desc: {
      ru: "Самая мощная модель для складов и больших пространств.",
      uz: "Omborlar va katta maydonlar uchun eng kuchli model.",
    },
    image: "/images/aircooler/8.png",
    tier: "industrial",
  },
];

// Recommendation logic for quiz
export const recommendModel = (segment, size) => {
  const map = {
    home: { small: "Z-1050", medium: "Z-1250", large: "Z-1380", xl: "Z-1530" },
    store: { small: "Z-1250", medium: "Z-1380", large: "Z-1530", xl: "Z-900" },
    cafe: { small: "Z-1380", medium: "Z-1530", large: "Z-1530", xl: "Z-900" },
    office: { small: "Z-1250", medium: "Z-1380", large: "Z-1530", xl: "Z-900" },
    warehouse: { small: "Z-1530", medium: "Z-1530", large: "Z-900", xl: "Z-900" },
  };
  return map[segment]?.[size] || "Z-1250";
};
